import { render } from "./WirepasJourneySidebar.vue?vue&type=template&id=04474e0f&scoped=true&ts=true"
import script from "./WirepasJourneySidebar.vue?vue&type=script&lang=ts"
export * from "./WirepasJourneySidebar.vue?vue&type=script&lang=ts"

import "./WirepasJourneySidebar.vue?vue&type=style&index=0&id=04474e0f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04474e0f"]])

export default __exports__